function RotateInfoIntro({ children }: { children: React.ReactNode }) {
  return (
    <p className="bg-ion-color-secondary text-ion-color-primary w-full rounded-2xl bg-opacity-80 p-3 text-3xl">
      {children}
    </p>
  )
}

export { RotateInfoIntro }
